import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./polyfills";

import "@/stylesheets/global/tailwind.scss";
import "@/stylesheets/global/main.scss";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import initMaterialIcons from "@/material-icons";

import i18n from "@/i18n";

import(
  /* webpackChunkName: "vue-tailwind" */ "@/vue-tailwind"
).then(vueTailwind => vueTailwind.setup());

Vue.config.productionTip = false;
store.commit("app/init");

library.add(faFacebookF);
Vue.component("FontAwesomeIcon", FontAwesomeIcon);

initMaterialIcons();

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
